<template>
  <v-container class="d-flex flex-column align-center">
    <div class="term" v-if="status != 7 && status != 0">
      <p v-html="message"></p>
      <v-btn @click="submit" class="success" depressed>I want to Cancel</v-btn>
    </div>
    <div class="term" v-else>
      <p v-html="message"></p>
    </div>
  </v-container>
</template>
<script>
import { functions, templates } from "../assets/js/firebase";
import { formatMessage, getDate } from "../assets/js/common";
import customerModal from "../assets/js/customer.modal";
export default {
  data() {
    return {
      loading: true,
      message: "",
      unsubscribe: null,
      status: 0,
      re: {}
    };
  },
  beforeDestroy() {
    if (this.unsubscribe !== null) this.unsubscribe();
  },
  methods: {
    async submit() {
      const vm = this;
      let { id } = vm.$route.params;
      vm.$root.loader = true;
      try {
        let updated_at = getDate();
        await functions.httpsCallable("jobCancel")({
          id,
          updated_at
        });
        vm.$root.loader = false;
        vm.status = -1;
        vm.message = "";
        vm.init();
      } catch (e) {
        vm.loading = false;
        vm.$root.loader = false;
        vm.$root.alert(e.message);
      }
    },
    async init() {
      const vm = this;
      let { id } = vm.$route.params;
      try {
        vm.$loader.show();
        let { data } = await functions.httpsCallable("getCustomer")({ id });
        vm.$loader.hide();
        if (data.data == null) {
          vm.message = "Job not found";
        } else {
          let {
            status,
            fields,
            job_number,
            template_name,
            disposition
          } = data.data;
          fields.Job_Type = template_name;
          fields.Job_Number = job_number;
          vm.status = status;
          vm.$root.loader = false;
          vm.getMessage({ status, fields, disposition });
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async getMessage({ status, fields, disposition }) {
      const vm = this;
      try {
        vm.message = "";
        vm.$root.loader = true;
        let id = "web-job-cancel";
        if (status == 7 && disposition == customerModal.DISPOSITION_CANCEL) {
          id = "web-job-cancellation-message";
        } else if (status == 7) id = "web-job-already-completed";
        let snap = await templates.doc(id).get();
        let { message } = snap.data();
        vm.message = formatMessage({
          message,
          fields,
          options: {},
          template_name: fields.Job_Type,
          job_number: fields.Job_Number
        });
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.term {
  max-width: 800px;
  padding: 10px;
  p {
    text-align: justify;
    color: #1e1f1f;
    font-weight: 500;
    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }
  }
}
</style>
